import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { terminalState } from './terminalState';
import { TerminalState } from '../types';

export const terminalSlice = createSlice({
  name: 'terminal',
  initialState: terminalState,
  reducers: {
    setTerminals: (
      state,
      action: PayloadAction<TerminalState['terminals']>,
    ) => {
      state.terminals = action.payload;
    },
    setTotalRecordCount: (state, action: PayloadAction<number>) => {
      state.totalRecordCount = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setAddEditModal: (
      state,
      action: PayloadAction<TerminalState['addEditModal']>,
    ) => {
      state.addEditModal = action.payload;
    },
    setDeleteModal: (
      state,
      action: PayloadAction<TerminalState['deleteModal']>,
    ) => {
      state.deleteModal = action.payload;
    },
    setCsvUploadModal: (state, action: PayloadAction<boolean>) => {
      state.csvUploadModal = action.payload;
    },
    setExportModalOpen: (state, action: PayloadAction<boolean>) => {
      state.exportModalOpen = action.payload;
    },
    setSubsetModal: (state, action: PayloadAction<boolean>) => {
      state.subsetModal = action.payload;
    },
    setResetData: () => terminalState,
  },
});

export const { actions: terminalActions } = terminalSlice;

export const selectTerminal = (state: RootState) => state.terminal;

export const selectTerminals = createSelector(
  selectTerminal,
  state => state.terminals,
);

export const selectTotalRecordCount = createSelector(
  selectTerminal,
  state => state.totalRecordCount,
);

export const selectSearch = createSelector(
  selectTerminal,
  state => state.search,
);

export const selectAddEditModal = createSelector(
  selectTerminal,
  state => state.addEditModal,
);

export const selectDeleteModal = createSelector(
  selectTerminal,
  state => state.deleteModal,
);

export const selectCsvUploadModal = createSelector(
  selectTerminal,
  state => state.csvUploadModal,
);

export const selectExportModalOpen = createSelector(
  selectTerminal,
  state => state.exportModalOpen,
);

export const selectsubsetModal = createSelector(
  selectTerminal,
  state => state.subsetModal,
);

export default terminalSlice.reducer;
